/* Birchwood theme JS: mobile nav, submenu toggles, testimonial carousel, cart qty */
(function () {
  // Mobile menu
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.getElementById('SiteNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // On mobile, first tap on a parent link opens its submenu
    nav.querySelectorAll('.site-nav__item.has-children > a, .site-nav__item.has-children > .site-nav__link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (window.matchMedia('(max-width: 1080px)').matches) {
          var li = link.parentElement;
          if (!li.classList.contains('is-open')) {
            e.preventDefault();
            li.classList.add('is-open');
          }
        }
      });
    });
  }

  // Testimonials carousel
  document.querySelectorAll('[data-testimonials]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-slide]');
    var dots = root.querySelectorAll('.testimonials__dot');
    if (slides.length < 2) return;
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.hidden = idx !== i; });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }
    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () { show(idx); });
    });
    setInterval(function () { show(i + 1); }, 7000);
    show(0);
  });

  // Cart quantity auto-submit
  document.querySelectorAll('.cart-qty').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  // Product gallery thumbs
  var mainImg = document.querySelector('[data-product-main-image]');
  document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = thumb.dataset.full;
      mainImg.srcset = '';
      document.querySelectorAll('[data-product-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // Product variant select -> update price/availability via options
  var variantScript = document.querySelector('[data-variant-json]');
  var idInput = document.querySelector('[data-variant-id]');
  if (variantScript && idInput) {
    var variants = JSON.parse(variantScript.textContent);
    var selects = document.querySelectorAll('[data-option-select]');
    function currentVariant() {
      var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (o, idx) { return o === opts[idx]; });
      });
    }
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        var v = currentVariant();
        var priceEl = document.querySelector('[data-product-price]');
        var btn = document.querySelector('[data-add-button]');
        if (v) {
          idInput.value = v.id;
          if (priceEl && v.price_formatted) priceEl.innerHTML = v.price_formatted;
          if (btn) {
            btn.disabled = !v.available;
            btn.textContent = v.available ? btn.dataset.addText : btn.dataset.soldText;
          }
        }
      });
    });
  }
})();
